import _asyncToGenerator from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import Gikam from 'gikam';
import { RsaEncryptUtils } from './rsaEncryptUtils';
import { I18N } from '@/gikam/i18n/I18N.js';
import Confirm from '@/gikam/js/components/confirm/confirm.js';
Gikam.component.Confirm = Confirm;
export var LoginUtils = /*#__PURE__*/function () {
  function LoginUtils() {
    _classCallCheck(this, LoginUtils);
  }

  _createClass(LoginUtils, null, [{
    key: "checkAccount",
    value: function () {
      var _checkAccount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(username, password) {
        var publicKey;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return RsaEncryptUtils.getPublicKey();

              case 2:
                publicKey = _context.sent;
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  var url = "".concat(Gikam.IFM_CONTEXT, "/core/module/sys/logins/action/check-account");
                  Gikam.post(url, Gikam.getJsonWrapper({
                    username: username,
                    password: RsaEncryptUtils.encode(publicKey, password)
                  }), {
                    'SECURITY-RSA-KEY': publicKey
                  }).done(function (data) {
                    if (data === true) {
                      resolve(publicKey);
                    }
                  }).fail(function (r) {
                    reject(Gikam.getI18NErrorMessage(JSON.parse(r.responseText).message));
                  });
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function checkAccount(_x, _x2) {
        return _checkAccount.apply(this, arguments);
      }

      return checkAccount;
    }()
  }, {
    key: "getDeptList",
    value: function () {
      var _getDeptList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(username, password, publicKey) {
        var url, json;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = Gikam.IFM_CONTEXT + '/secure/core/module/mdm/user-permissions/login-org/queries/post-selectable';
                json = Gikam.getJsonWrapper({
                  username: username,
                  password: RsaEncryptUtils.encode(publicKey, password)
                });
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  Gikam.post(url, json, {
                    'SECURITY-RSA-KEY': publicKey
                  }).done(function (deptList) {
                    return resolve(deptList);
                  }).fail(function (r) {
                    return reject(r);
                  });
                }));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getDeptList(_x3, _x4, _x5) {
        return _getDeptList.apply(this, arguments);
      }

      return getDeptList;
    }()
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(username, password, orgId, roleId, loginType, captcha, param) {
        var publicKey, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return RsaEncryptUtils.getPublicKey();

              case 2:
                publicKey = _context3.sent;
                data = {
                  id: username,
                  password: RsaEncryptUtils.encode(publicKey, password)
                };

                if (orgId) {
                  data.orgId = orgId;
                }

                if (roleId) {
                  data.roleId = roleId;
                }

                if (captcha) {
                  data.captcha = captcha;
                }

                if (loginType === 1) {
                  data.loginType = 'AD';
                  LoginUtils.setLoginType('AD');
                } else {
                  LoginUtils.setLoginType(null);
                }

                LoginUtils.setLoginUserId(username);
                LoginUtils.setLoginOrgId(orgId);
                LoginUtils.setLoginRoleId(roleId);
                return _context3.abrupt("return", new Promise(function (resolve, reject) {
                  var url = Gikam.IFM_CONTEXT + '/core/module/sys/login' + location.search;
                  Gikam.ajax({
                    url: Gikam.addUrlParam(url, param),
                    type: 'post',
                    data: data,
                    beforeSend: function beforeSend(xhr) {
                      xhr.setRequestHeader('SECURITY-RSA-KEY', publicKey);
                    }
                  }).done(function () {
                    location.href = Gikam.IFM_CONTEXT + '/module/index/workspaces' + location.search;
                    resolve();
                  }).fail(function (r) {
                    var result = JSON.parse(r.responseText);

                    if (result.status === 402) {
                      Gikam.confirm(null, I18N.prop('login.account.login.repeat', {
                        IP: result.message
                      }), function () {
                        LoginUtils.login(username, password, orgId, roleId, loginType, captcha, {
                          force: 1
                        });
                      });
                      reject();
                    } else {
                      reject(Gikam.getI18NErrorMessage(result.message));
                    }
                  });
                }));

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function login(_x6, _x7, _x8, _x9, _x10, _x11, _x12) {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: "getRoleList",
    value: function () {
      var _getRoleList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(username, password, publicKey) {
        var url;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                url = Gikam.IFM_CONTEXT + '/secure/core/module/mdm/user-permissions/login-role/queries/post-selectable';
                return _context4.abrupt("return", new Promise(function (resolve, reject) {
                  Gikam.post(url, Gikam.getJsonWrapper({
                    username: username,
                    password: RsaEncryptUtils.encode(publicKey, password)
                  }), {
                    'SECURITY-RSA-KEY': publicKey
                  }).done(function (list) {
                    return resolve(list || []);
                  }).fail(function (r) {
                    return reject(r);
                  });
                }));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function getRoleList(_x13, _x14, _x15) {
        return _getRoleList.apply(this, arguments);
      }

      return getRoleList;
    }()
  }, {
    key: "getDefaultDeptOrRoleItem",
    value: function getDefaultDeptOrRoleItem(list, name) {
      var defaultValue = null;
      var items = list.map(function (item) {
        if (item.defaultFlag === '1') {
          defaultValue = item.targetId;
        }

        return {
          value: item.targetId,
          text: item.ext$[name],
          defaultFlag: item.defaultFlag
        };
      });

      if (items.length === 1) {
        defaultValue = items[0].value;
      }

      return {
        items: items,
        defaultValue: defaultValue
      };
    }
  }, {
    key: "getDefaultDeptItem",
    value: function getDefaultDeptItem(list) {
      return LoginUtils.getDefaultDeptOrRoleItem(list, 'orgname');
    }
  }, {
    key: "getDefaultRoleItem",
    value: function getDefaultRoleItem(list) {
      return LoginUtils.getDefaultDeptOrRoleItem(list, 'rolename');
    }
  }, {
    key: "setLoginType",
    value: function setLoginType(loginType) {
      if (!loginType) {
        localStorage.removeItem('loginType');
      } else {
        localStorage.setItem('loginType', loginType);
      }
    }
  }, {
    key: "setLoginUserId",
    value: function setLoginUserId(userId) {
      localStorage.setItem('loginUserId', userId);
    }
  }, {
    key: "getLoginUserId",
    value: function getLoginUserId() {
      return localStorage.getItem('loginUserId') || Gikam.loginUser.id;
    }
  }, {
    key: "setLoginOrgId",
    value: function setLoginOrgId(orgId) {
      localStorage.setItem('loginOrgId', orgId);
    }
  }, {
    key: "getLoginOrgId",
    value: function getLoginOrgId() {
      return localStorage.getItem('loginOrgId') === 'null' ? '' : localStorage.getItem('loginOrgId');
    }
  }, {
    key: "setLoginRoleId",
    value: function setLoginRoleId(roleId) {
      localStorage.setItem('loginRoleId', roleId);
    }
  }, {
    key: "getLoginRoleId",
    value: function getLoginRoleId() {
      return localStorage.getItem('loginRoleId') === 'null' ? '' : localStorage.getItem('loginRoleId');
    }
  }, {
    key: "getLoginType",
    value: function getLoginType() {
      return localStorage.getItem('loginType');
    } //找回密码时发送邮件

  }, {
    key: "hasUser",
    value: function hasUser(_ref) {
      var userId = _ref.userId,
          email = _ref.email;
      return new Promise(function (resolve, reject) {
        Gikam.postText(Gikam.IFM_CONTEXT + "/open/core/module/mdm/user-passwords/userId/".concat(userId, "/email/").concat(email, "/action/send-email")).done(function () {
          return resolve();
        }).fail(function (r) {
          return reject(Gikam.getI18NErrorMessage(JSON.parse(r.responseText).message));
        });
      });
    } //校验重置密码 链接是否有效

  }, {
    key: "validatePasswordRecoveryLink",
    value: function validatePasswordRecoveryLink(_ref2) {
      var userId = _ref2.userId,
          secretKey = _ref2.secretKey;
      return new Promise(function (resolve, reject) {
        Gikam.postText(Gikam.IFM_CONTEXT + "/open/core/module/mdm/user-passwords/userId/".concat(userId, "/key/").concat(secretKey, "/action/validate-url")).done(function () {
          return resolve();
        }).fail(function () {
          return reject();
        });
      });
    } //获取密码策略

  }, {
    key: "getPasswordPolicy",
    value: function getPasswordPolicy(_ref3) {
      var userId = _ref3.userId;
      return new Promise(function (resolve, reject) {
        Gikam.getJson(Gikam.IFM_CONTEXT + "/open/core/module/mdm/user-passwords/userId/".concat(userId, "/password-policies/queries ")).done(function (data) {
          return resolve(data);
        }).fail(function () {
          return reject();
        });
      });
    } //重置密码

  }, {
    key: "sendRestPassword",
    value: function sendRestPassword(params) {
      return new Promise(function (resolve, reject) {
        Gikam.postText(Gikam.IFM_CONTEXT + '/open/core/module/mdm/user-passwords/action/reset', Gikam.getJsonWrapper({}, ['', [params]])).done(function () {
          return resolve();
        }).fail(function (r) {
          return reject(Gikam.propI18N(r.responseText));
        });
      });
    } //获取手机验证码

  }, {
    key: "getVerificationCode",
    value: function () {
      var _getVerificationCode = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(userId, mobile) {
        var url;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                url = Gikam.IFM_CONTEXT + "/open/core/module/mdm/user-passwords/users/".concat(userId, "/").concat(mobile, "/action/send-sms");
                return _context5.abrupt("return", new Promise(function (resolve, reject) {
                  Gikam.post(url).done(function (r) {
                    r.value ? reject(Gikam.propI18N(r.value)) : resolve();
                  });
                }));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function getVerificationCode(_x16, _x17) {
        return _getVerificationCode.apply(this, arguments);
      }

      return getVerificationCode;
    }() //手机找回密码验证接口

  }, {
    key: "checkUserOfMobile",
    value: function () {
      var _checkUserOfMobile = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(userId, code) {
        var url;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                url = Gikam.IFM_CONTEXT + "/open/core/module/mdm/user-passwords/users/".concat(userId, "/action/check-sms-vc");
                return _context6.abrupt("return", new Promise(function (resolve, reject) {
                  Gikam.postText(url, Gikam.getJsonWrapper({
                    verificationCode: code
                  })).done(function (r) {
                    return resolve(r);
                  }).fail(function (r) {
                    reject(JSON.parse(r.responseText).message);
                  });
                }));

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function checkUserOfMobile(_x18, _x19) {
        return _checkUserOfMobile.apply(this, arguments);
      }

      return checkUserOfMobile;
    }() //手机找回密码 修改密码接口

  }, {
    key: "sendRestPasswordByMobile",
    value: function () {
      var _sendRestPasswordByMobile = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(userId, params) {
        var url;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                url = Gikam.IFM_CONTEXT + "/open/core/module/mdm/user-passwords/users/".concat(userId, "/action/reset-by-sms");
                return _context7.abrupt("return", new Promise(function (resolve, reject) {
                  Gikam.postText(url, Gikam.getJsonWrapper(params)).done(function (r) {
                    return resolve(r);
                  }).fail(function (r) {
                    reject(Gikam.getI18NErrorMessage(Gikam.propI18N(r.responseText)));
                  });
                }));

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function sendRestPasswordByMobile(_x20, _x21) {
        return _sendRestPasswordByMobile.apply(this, arguments);
      }

      return sendRestPasswordByMobile;
    }()
  }]);

  return LoginUtils;
}();